import React from "react";
import { useTranslation } from "react-i18next";
import { Parallax } from "rc-scroll-anim";
import { featuresData } from "../../_constants/staticData";
import feature from "../../assets/images/features.jpg";

function FeaturesPage() {
    const { t } = useTranslation();

    return (
        <div className="FeaturesPage">
            <div className="title-wrapper animate-from-bottom">
                <div className="inner-wrapper">
                    <h1>
                        {featuresData.header}
                        {/*{t("pricing.No Risk")}*/}
                    </h1>
                    <p>{featuresData.subHeader}</p>
                </div>
            </div>

            <div className='featured-image-wrapper'>
                <img src={feature} alt='Featured' loading="lazy"/>
            </div>

            <div className="features-wrapper">
                {featuresData.features.map((featureContent, index) => (
                    <div key={index + "fc"}>
                        <div className="subtitle-wrapper">
                            <Parallax
                                animation={[
                                    {
                                        opacity: 0,
                                        blur: "10px",
                                        playScale: [0, 0.1],
                                    },
                                    {
                                        opacity: 1,
                                        blur: "0px",
                                        playScale: [0, 0.1],
                                    },
                                ]}
                                className="title"
                            >
                                {t(`features.${featureContent.title}`)}
                            </Parallax>

                            <Parallax
                                animation={[
                                    {
                                        translateY: "-1rem",
                                        opacity: 0,
                                        playScale: [0, 0.1],
                                    },
                                    {
                                        translateY: "1rem",
                                        opacity: 1,
                                        playScale: [0, 0.5],
                                    },
                                ]}
                                className="sub-text"
                            >
                                {featureContent.description}
                            </Parallax>
                        </div>
                        <div className="inner-wrapper">
                            {featureContent.featuresList.map(
                                (feature, index) => (
                                    <div
                                        key={index + "fl"}
                                        className="features-list"
                                    >
                                        <div className="features-icon">
                                            <img
                                                src={feature.imgSrc}
                                                alt="Course Builder"
                                                style={{width:"70px"}}
                                            />
                                        </div>
                                        <div className="features-content">
                                            <span className="sub-title">
                                                {feature.title}
                                            </span>
                                            <p>{feature.description}</p>
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default FeaturesPage;
